import type { Locale } from './locale';

const dateFormats = new Map<string, Intl.DateTimeFormat>();
const numberFormats = new Map<string, Intl.NumberFormat>();
const relativeFormats = new Map<Locale, Intl.RelativeTimeFormat>();
export const intlLocale = (locale: Locale) =>
  locale === 'fa' ? 'fa-IR-u-ca-persian-nu-arabext' : 'en-US';
export const formatDate = (
  value: Date | string | number,
  locale: Locale,
  options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' },
) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  const key = JSON.stringify([locale, options]);
  let formatter = dateFormats.get(key);
  if (!formatter) {
    formatter = new Intl.DateTimeFormat(intlLocale(locale), options);
    dateFormats.set(key, formatter);
  }
  return formatter.format(date);
};
export const formatNumber = (
  value: number,
  locale: Locale,
  options: Intl.NumberFormatOptions = {},
) => {
  const key = JSON.stringify([locale, options]);
  let formatter = numberFormats.get(key);
  if (!formatter) {
    formatter = new Intl.NumberFormat(intlLocale(locale), options);
    numberFormats.set(key, formatter);
  }
  return formatter.format(value);
};
export const formatRelativeTime = (
  value: number,
  unit: Intl.RelativeTimeFormatUnit,
  locale: Locale,
) => {
  let formatter = relativeFormats.get(locale);
  if (!formatter) {
    formatter = new Intl.RelativeTimeFormat(intlLocale(locale), { numeric: 'auto' });
    relativeFormats.set(locale, formatter);
  }
  return formatter.format(value, unit);
};
/** Normalize only numeric input fields; never apply to passwords or opaque identifiers. */
export const normalizeDigits = (value: string) =>
  value.replace(/[۰-۹٠-٩]/g, (digit) => String(digit.charCodeAt(0) - (digit >= '۰' ? 1776 : 1632)));
